const KEY = "tc_cookie_consent";

export const getCookieConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
};

export const applyCookieConsent = (c) => {
  const ph = window.posthog;
  if (!ph) return;
  try { c?.statistics ? ph.opt_in_capturing() : ph.opt_out_capturing(); } catch { /* analytics optional */ }
};

export const saveCookieConsent = (statistics, choice) => {
  const c = { statistics, choice, at: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  applyCookieConsent(c);
  window.dispatchEvent(new Event("tc-cookie-consent"));
  return c;
};
